export enum ActivitySource {
  ENGLISH_CENTRAL = 1,
  SPEECHACE = 8,
  ISC = 9,
}



// WEBPACK FOOTER //
// ./ts/app/activity-calendar/activity-snippet/activity-source.ts